"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AgentType = {
  Unknown: {
    index: 0,
    name: 'Unknown',
    label: 'Unknown'
  },
  Agent: {
    index: 1,
    name: 'Agent',
    label: 'Agent'
  },
  PrivateLister: {
    index: 2,
    name: 'PrivateLister',
    label: 'Private Lister'
  },
  Valuer: {
    index: 3,
    name: 'Valuer',
    label: 'Valuer'
  },
  Builder: {
    index: 4,
    name: 'Builder',
    label: 'Builder'
  },
  Developer: {
    index: 5,
    name: 'Developer',
    label: 'Developer'
  },
  BannerAdvertiser: {
    index: 6,
    name: 'BannerAdvertiser',
    label: 'Corporate Banner Advertiser'
  },
  TradesAndServices: {
    index: 7,
    name: 'TradesAndServices',
    label: 'Business Directory'
  },
  AgentBannerAdvertiser: {
    index: 8,
    name: 'AgentBannerAdvertiser',
    label: 'Agent Banner Advertiser'
  }
};
var _default = exports.default = AgentType;